import React, { useState } from "react";
import { AlertCircle, FileText } from "lucide-react";
import { NumbersService } from "../../services/numbers";
import { useTranslation } from 'react-i18next';
import "./DocumentCards.scss";

const ReceiptCard = ({ doc }) => {
  const [showAlert, setShowAlert] = useState(false);

  const hasFile = !!doc.receipt_file_link;
  const { t } = useTranslation();

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const handleClick = () => {
    if (!hasFile) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }
    window.open(doc.receipt_file_link, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <div className="document-card" onClick={handleClick}>
        <div className="document-info">
          <div
            className="document-icon"
            style={{ color: hasFile ? "#60BB46" : "#9ca3af" }}
          >
            <FileText />
          </div>

          <div>
            <div className="document-number">{doc.receipt_number}</div>
            <div className="document-date">{formatDate(doc.created_on)}</div>
            <div className="client-name">{doc.clientNameView.toLowerCase()}</div>
          </div>
        </div>

        <div>
          {doc.amount && (
            <div className="document-amount amount-container" style={{ direction: 'rtl' }}>
              <p> {NumbersService.numberWithCommas(doc.amount)}</p>
              <p>₪</p>
            </div>
          )}</div>
      </div>

      {showAlert && (
        <div className="document-alert-wrapper">
          <div className="document-alert"
          >
            <div className="document-alert-box">
              <div className="alert-icon">
                <AlertCircle />
              </div>
              <div className="alert-text">
                <h3>{t('document-not-available')}</h3>
                <p>{t('try-again-later')}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReceiptCard;
